<template>
  <section id="reset-pass" class="reset-wrapper container">
    <div class="reset-wrapper-inner">
      <div class="email-success" v-if="showSuccessBanner">
        <div class="notification-wrapper">
          <div class="welcome">
            <img src="../assets/welcome.svg" />
          </div>
          <div
            class="message"
          >Check your email, we just sent you a link to complete the reset of your password</div>
        </div>
      </div>
      <section class="form-wrapper" v-if="!showSuccessBanner">
        <h2>Reset Password</h2>

        <div class="message-error"></div>

        <form id="reset-password-form" v-on:submit.prevent="onSubmit" novalidate>
          <fieldset>
            <div class="form-label">
              <label for="reset-password-email">Email</label>
              <div class="error-message" v-if="!$v.email.required && $v.email.$dirty">Field required</div>
              <div
                class="error-message"
                v-if="!$v.email.email && $v.email.$dirty"
              >Must be a valid email</div>
            </div>
            <input
              type="email"
              name="email"
              placeholder="email"
              class="resetp"
              v-bind:class="{ error: $v.email.$error && $v.email.$dirty }"
              v-model.trim.lazy="$v.email.$model"
              aria-label="email"
            />
          </fieldset>
          <input type="submit" value="Reset Password" class="btn" v-bind:class="{ busy: loading }" />
        </form>
      </section>
      <div class="reset-login" v-if="!showSuccessBanner">
        <p class="secondary-action">
          or
          <router-link class :to="{ name: 'login' }">Login</router-link>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import authService from '../auth/authService';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'ResetPassword',
  data () {
    return {
      email: null,
      auth0error: null,
      successMessage: null,
      loading: false
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {
    showSuccessBanner () {
      return this.successMessage || false;
    }
  },
  methods: {
    onSubmit () {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.auth0error = null;
        this.loading = true;
        authService.resetPasswordRequest(this.email, this.onResetErrorCallback);
      }
    },
    onResetErrorCallback (error, resp) {
      this.loading = false;
      if (error) {
        this.auth0error = error.description;
      } else {
        this.successMessage = resp;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.reset-wrapper {
  .reset-wrapper-inner {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-width: 100%;

    .secondary-action {
      border-left: 0;
      border-top: 1px solid $fog;
      margin: 45px auto;
      padding: 27px 0 0;
      text-align: center;

      a {
        margin-left: 5px;
      }
    }
  }

  .message {
    text-transform: initial;
  }
}

.reset-login {
  width: 100%;

  .secondary-action {
    margin: auto;
    width: $column-width;

    a {
      @extend %text-link;
    }
  }
}
</style>
